import { SpotlightDocumentSchema } from "@redotech/redo-model/spotlight-document-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const duplicateSpotlight = {
  name: "duplicateSpotlight" as const,
  input: z.object({ spotlightId: zExt.objectId() }),
  output: z.object({ spotlight: SpotlightDocumentSchema }),
};
